import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Pontuacao } from './pontuacao';
import { PontuacaoBeneficio } from './pontuacao-beneficio';
import { PontuacaoService } from './pontuacao.service';
import { Estudo } from '../estudo/estudo';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { PagerComponent } from '../paginator/pager.component';
import { RespostaListaDinamicaService } from 'unb-questionario-componente';


@Component({
  templateUrl: './pontuacao-detail.component.html',
  selector: 'pontuacao-detail'
})
export class PontuacaoDetailComponent implements OnInit {
  public estudo: Estudo;
  @Input()idEstudo: number;
  public itemSelecionado: Pontuacao;
  public lista: Pontuacao[];
  public botaoSalvar: boolean;
  // controla o loading da pagina
  // private isLoading: boolean;
  public isLoading: boolean;
  public solicitouMoradia: boolean;
  public filtro: string;
  public selecionarMembros: boolean;

  @Output() pontuacaoEmitida: EventEmitter<number> = new EventEmitter<number>();
  // construtor
  constructor(
    private pontuacaoService: PontuacaoService,
    private estudoService: EstudoService,
    private router: Router,
    private route: ActivatedRoute,
    public mensagem: MatSnackBar
  ) {}

  // ngOnInit é executado ao entrar na tela
  ngOnInit() {
    this.filtro = this.route.snapshot.params['filtro'];
    this.carregaEstudo();
  }

  carregaEstudo() {
    let id: any = this.route.snapshot.params['id'];
    // se chegar aki, eh pq veio por um componente
    if (this.idEstudo){
      id = this.idEstudo;
    }
    
    if (id && id != 'new') {
      this.isLoading = true;
      this.estudoService.getId(parseInt(id)).subscribe(
        result => {
          this.estudo = result;
          // primeiro eu busco pra ver se esse estudo jah tem pontuacao.
          this.buscar();
        },
        error => this.erro(error)
      );
    }else{
      this.mensagem.open('Erro ao carregar Id do Estudo!', 'X', {
        duration: 5000
      });
    }
  }

  // busca com filtro
  buscar() {
    this.isLoading = true;
    const pontuacao: Pontuacao = new Pontuacao();
    pontuacao.codigoEstudoSocioEconomico = this.estudo.id;
    this.pontuacaoService.filtrar(pontuacao).subscribe(
      (results: Pontuacao[]) => {
        if (results && results.length > 0) {
          this.lista = results;
          let existePontuacaoValida = false;
          results.forEach((pontuado: Pontuacao) => {
            if (
              pontuado.dataEncerramento == null ||
              pontuado.dataEncerramento == undefined
            ) {
              existePontuacaoValida = true;
            }
            pontuado = this.formataPontuacao(pontuado);
          });
          // se nao achou nada, entao carrega a lista de membros para seleção
          if (!existePontuacaoValida) {
            this.selecionarMembros = true;
          } else {
            this.selecionarMembros = false;
          }
        } else {
          // se nao encontrou, entao eu tenho que pedir pra selecionar os membros
          this.selecionarMembros = true;
        }

        this.isLoading = false;
      },
      error => this.erro(error)
    );
  }

  membrosSelecionados(membroSelecionados: number[]) {
    this.selecionarMembros = false;
    this.carregaPontuacao(this.estudo, membroSelecionados);
  }

  carregaPontuacao(estudo: Estudo, membroSelecionados: number[]) {
    this.isLoading = true;
    this.pontuacaoService
      .realizarPontuacao(estudo.id, membroSelecionados)
      .subscribe(
        (pontuacaoNova: Pontuacao) => {
          pontuacaoNova.codigoEstudoSocioEconomico = estudo.id;
          pontuacaoNova = this.formataPontuacao(pontuacaoNova);
          if (this.lista == null) {
            this.lista = new Array();
          }
          this.lista.push(pontuacaoNova);

          this.isLoading = false;
        },
        error => this.erro(error)
      );
  }

  formataPontuacao(pontuacao: Pontuacao) {
    return pontuacao;
  }

  beneficioRecebido(beneficio: PontuacaoBeneficio) {
    // tenho que achar o beneficio na minha lista
    this.lista.forEach((pontuacao: Pontuacao) =>
      pontuacao.beneficios.forEach(ben => {
        if (ben.beneficio == beneficio.beneficio) {
          ben = beneficio; // e atribuir o valor
        }
      })
    );
  }

  salvar(pontuacao: Pontuacao) {
    this.isLoading = true;
    this.botaoSalvar = false;
    this.pontuacaoService.update(pontuacao).subscribe(
      result => {
        this.isLoading = false;
        this.mensagem.open('Registro salvo com sucesso!', 'X', {
          duration: 5000
        });
        this.estudo.situacao = SituacaoEnum.Pontuado;
        this.estudo.situacaoDenominacao = 'Pontuado';
        this.pontuacaoEmitida.emit(result.id);
        this.buscar();
      },
      error => {
        this.erro(error);
        this.botaoSalvar = true;
      }
    );
  }

  encerrarPontuacao(pontuacao: Pontuacao) {
    this.isLoading = true;

    this.pontuacaoService.encerrarPontuacao(pontuacao).subscribe(
      result => {
        this.isLoading = false;
        this.estudo.situacao = SituacaoEnum.Homologado;
        this.estudo.situacaoDenominacao = 'Homologado';
        this.buscar();
        this.mensagem.open('Pontuação encerrada com sucesso!', 'X', {
          duration: 5000
        });
      },
      error => {
        this.mensagem.open(error, 'X', { duration: 5000 });
        this.isLoading = false;
      }
    );
  }

  // mostra erros na tela
  erro(erro: string) {
    this.mensagem.open(erro, 'X', { duration: 5000 });
    this.isLoading = false;
  }

  // finaliza o subscribe
  finaliza() {
    this.isLoading = false;
  }

  voltar() {
    this.router.navigate(['/estudolist', { filtro: this.filtro }]);
  }
}
